/*@ngInject*/
const SectionTemplateActionRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.loadSectionTemplateActions = function (sectionTemplateId) {
        var url = '/rest/Actions',
            config = {
                params: {
                    uri: 'com.firstbest.underwriting.proposal.SectionTemplate:' + sectionTemplateId
                }
            };

        return this.get(url, config);
    };
};

angular.module('ums.configuration')
    .service('sectionTemplateActionRepository', SectionTemplateActionRepository);
